import { DownloadSimple } from "@phosphor-icons/react";
import { exportRowsToXlsx } from "../lib/exportXlsx";

/** Compact "Export XLSX" button. Pass the filename, column defs and the currently
 *  displayed rows; it downloads exactly what the user sees (filters/sort respected). */
export function ExportXlsxButton({ filename, columns, rows, sheetName, testid = "export-xlsx-btn", disabled }) {
  const isDisabled = disabled || !rows || rows.length === 0;
  return (
    <button
      type="button"
      className="jde-btn jde-btn-sm"
      data-testid={testid}
      disabled={isDisabled}
      title={isDisabled ? "Nothing to export" : `Export ${rows.length} rows to Excel`}
      onClick={() => exportRowsToXlsx(filename, columns, rows, sheetName)}
      style={{ display: "inline-flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}
    >
      <DownloadSimple size={13} weight="bold" /> Export XLSX
    </button>
  );
}
